module['exports'] = {
  wide: [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئ',
    'جون',
    'جولائ',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر',
  ],
  wide_context: [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئ',
    'جون',
    'جولائ',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر',
  ],
};
